import { render, staticRenderFns } from "./RelatorioPainelListagemTabela.vue?vue&type=template&id=f483cb96&scoped=true"
import script from "./RelatorioPainelListagemTabela.vue?vue&type=script&lang=js"
export * from "./RelatorioPainelListagemTabela.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPainelListagemTabela.vue?vue&type=style&index=0&id=f483cb96&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f483cb96",
  null
  
)

export default component.exports